var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saveArticle"
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/back.png")
    },
    on: {
      "click": _vm.hideCur
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saveArticle_c"
  }, [_c('ul', _vm._l((_vm.saveArticles), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goArticle(item.date)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.author))])])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-79e64139","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@13.0.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/saveArticle.vue
// module id = K39l
// module chunks = 1